import React, { PureComponent } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Mutation, Query } from "react-apollo";
import Link from "next/link";
import gql from "graphql-tag";

import Head from "../../components/head-data/head-data";
import PageHeading from "../../components/page-heading/page-heading";
import CommunityQuestion from "../../components/community-question/community-question";

import getParameterByName from "../../utils/get-url-param-by-name";
import { perPageCommunityQuestions } from "../../config";
import COMMUNITY_QUESTIONS_QUERY, {
  MOST_ANSWERED_QUESTIONS_QUERY,
  WAITING_QUESTIONS_QUERY,
} from "../../queries/community-questions-query";
import { LOCAL_TOGGLE_OVERLAY_MUTATION } from "../../apollo-state/graphql/mutations";

import "./the-nest.scss";

const QUESTIONS_CONNECTION_QUERY = gql`
  query QUESTIONS_CONNECTION_QUERY {
    questionsConnection(where: { approved: true }) {
      aggregate {
        count
      }
    }
  }
`;

class Index extends PureComponent {
  render() {
    const { me, query, toggleOverlay } = this.props;
    let pageNumber = Number(getParameterByName("pageidxref"));
    let pageName = "The Nest";
    if (!pageNumber && query.slug) {
      pageNumber = Number(query.slug.replace("page-", ""));
    }
    if (!pageNumber) pageNumber = 1;
    // Most answered by default: the answered questions are the Nest's best
    // content, and the recent ones are still waiting (hero-redesign-plan §2)
    const newest = query.sort === "newest";
    const listQuery = newest ? COMMUNITY_QUESTIONS_QUERY : MOST_ANSWERED_QUESTIONS_QUERY;
    const sortQuery = newest ? "?sort=newest" : "";
    const variables = {
      first: perPageCommunityQuestions,
    };
    if (pageNumber > 1) {
      variables.skip = (pageNumber - 1) * perPageCommunityQuestions;
      pageName = `The Nest - Page ${pageNumber}`;
    }
    return (
      <div className="index">
        <Head
          title={pageName}
          description="Here is where you can ask anything startup related!"
          url="https://www.foundercloud.com/the-nest"
        />
        <PageHeading
          title="Ask founders who&rsquo;ve been there."
          subHeader="Questions and answers on finding a co-founder and building a startup."
          actions={
            me ? (
              <Link href="/the-nest/ask">
                <a className="nest-top__ask">Ask a question</a>
              </Link>
            ) : (
              <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
                {(signUp) => (
                  <button type="button" className="nest-top__ask" onClick={() => signUp()}>
                    Ask a question
                  </button>
                )}
              </Mutation>
            )
          }
        />
        <div className="page__grid">
          <div className="ask-comm">
            <ReactCSSTransitionGroup
              transitionName="overlay"
              transitionAppear={true}
              component={React.Fragment}
              transitionAppearTimeout={500}
              transitionEnter={false}
              transitionLeave={false}
            >
              <div className="nest-layout">
              <div className="ask-comm__inner">
                <nav className="nest-sort" aria-label="Sort questions">
                  <Link href="/the-nest">
                    <a className="nest-sort__tab" aria-current={newest ? undefined : "page"}>
                      Most answered
                    </a>
                  </Link>
                  <Link href="/the-nest?sort=newest">
                    <a className="nest-sort__tab" aria-current={newest ? "page" : undefined}>
                      Newest
                    </a>
                  </Link>
                </nav>
                <div className="ask-comm__quests">
                  <Query query={listQuery} variables={variables}>
                    {({ data, loading, error }) => {
                      if (loading) return <p>loading...</p>;
                      if (error || !data) return null;
                      const questions =
                        (newest ? data.questions : data.questionsMostAnswered) || [];
                      return questions.map((article) => (
                        <CommunityQuestion
                          key={article.id}
                          {...article}
                          myId={me ? me.id : null}
                          referencePageNumber={pageNumber}
                          toggleOverlay={toggleOverlay}
                        />
                      ));
                    }}
                  </Query>
                </div>
                <Query query={QUESTIONS_CONNECTION_QUERY}>
                  {({ data, loading, error }) => {
                    if (loading) return <p>loading...</p>;
                    const amountOfQuestions =
                      data.questionsConnection.aggregate.count;
                    const totalPages = Math.ceil(
                      amountOfQuestions / perPageCommunityQuestions
                    );
                    return (
                      <div className="ask-comm__pag">
                        {pageNumber > 1 && (
                          <Link
                            href={
                              pageNumber !== 2
                                ? `/the-nest?slug=page-${pageNumber - 1}${newest ? "&sort=newest" : ""}`
                                : `/the-nest${sortQuery}`
                            }
                            as={
                              pageNumber !== 2
                                ? `/the-nest/page-${pageNumber - 1}${sortQuery}`
                                : `/the-nest${sortQuery}`
                            }
                          >
                            <a className="ask-comm__pag__button">← Prev</a>
                          </Link>
                        )}
                        {amountOfQuestions > perPageCommunityQuestions &&
                          totalPages > pageNumber && (
                            <Link
                              href={`/the-nest?slug=page-${pageNumber + 1}${newest ? "&sort=newest" : ""}`}
                              as={`/the-nest/page-${pageNumber + 1}${sortQuery}`}
                            >
                              <a className="ask-comm__pag__button">More →</a>
                            </Link>
                          )}
                        <div className="ask-comm__pag__pag-numbers">
                          page <strong>{pageNumber}</strong> of{" "}
                          <strong>{totalPages}</strong>
                        </div>
                      </div>
                    );
                  }}
                </Query>
              </div>
              <Query query={WAITING_QUESTIONS_QUERY}>
                {({ data }) => {
                  const waiting = (data && data.questions) || [];
                  if (waiting.length === 0) return null;
                  return (
                    <aside className="nest-waiting" aria-labelledby="nest-waiting-title">
                      <h2 id="nest-waiting-title" className="nest-waiting__title">
                        Waiting for a first answer
                      </h2>
                      <ul className="nest-waiting__list">
                        {waiting.map((q) => (
                          <li key={q.id}>
                            <Link href="/the-nest/q/[slug]" as={`/the-nest/q/${q.slug}`}>
                              <a>{q.title}</a>
                            </Link>
                          </li>
                        ))}
                      </ul>
                      <p className="nest-waiting__note">Know the answer? Founders asking here will see it.</p>
                    </aside>
                  );
                }}
              </Query>
              </div>
            </ReactCSSTransitionGroup>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
